import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseServices } from 'src/app/kuba/kuba.services';

import { ConfirmationService, SelectItem } from 'primeng/api';
import { SJAFormServices } from '../sjaform.routing';
import { ApprovalNotices } from './../../follow-ups/models/riskanalysis';
import { Subscription } from 'rxjs';
import { FeatureKey, Roles } from 'src/app/_models/feature';
import { SjaForm } from './sja-form';

@Component({
  selector: 'app-sja-list',
  templateUrl: './sja-list.component.html',
  styles: [],
  standalone: false
})
export class SjaListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  sjaDataList = [];
  roleId: number;
  featureKey: number;
  loading = false;
  sentMail = false;
  isFollowUpModule = false;
  selectedSJA: any = [];
  parentId: any;
  approvalNotices: any = [];
  parentKey: any;
  rowID: number = null;
  isCollapsed = false;
  isApproved = false;
  isInBusinessLevel = true;
  checkRole: boolean;
  isAdminOrPortalLevel: boolean;
  Business: SelectItem[];
  showApprovalTable = true;
  hasRights: boolean;
  canCreateSjaForm: boolean;
  guestEditAccess: boolean;
  loginUserName: string;
  userRole: string;
  isUser: boolean;
  showInfo: boolean;
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private SJAFormServices: SJAFormServices,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    this.parentKey = route.snapshot.parent.parent.data['parent'];
    let workingModule = <any>(
      JSON.parse(sessionStorage.getItem('workingModule'))
    );
    this.parentId = workingModule.id;
  }

  ngOnInit() {
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
    this.isAdminOrPortalLevel =
      Number(BaseServices.roleId) === Roles.PORTAL ||
      Number(BaseServices.roleId) === Roles.ADMIN
        ? false
        : true;
    if (this.isAdminOrPortalLevel) {
      this.sjaDataList = this.route.snapshot.data['list'];
    }
    this.roleId = +BaseServices.roleId;
    if (this.isAdminOrPortalLevel == false) {
      this.isInBusinessLevel = false;
      this.isApproved = true;
      this.showApprovalTable = false;
    }

    this.featureKey = this.route.snapshot.parent.parent.params['id'];
    this.featureKey =
      this.parentId === FeatureKey.FOLLOW_UP
        ? (this.featureKey = 0)
        : this.featureKey;
    if (this.parentId === FeatureKey.FOLLOW_UP) {
      this.isFollowUpModule = true;
    }

    this.bindApprovalNoticeList();
    this.bindBusinessDropDown();
    let businessList = this.route.snapshot.data['business'];
    let userRights = JSON.parse(BaseServices.getUserRights());
    let checkSJAFormRight;
    if (userRights != null) {
      checkSJAFormRight = userRights.filter(
        x => x.id == 47 && x.isChecked == true
      );
    }
    this.userRole = BaseServices.UserRole;
    this.canCreateSjaForm = this.roleId === Roles.EDITOR;
    this.hasRights =
      this.userRole == 'Editor'
        ? true
        : this.userRole == 'User' && checkSJAFormRight.length == 1
          ? true
          : this.userRole == 'Guest'
            ? false
            : false;
    this.loginUserName = BaseServices.Name;
  }

  /**
   * Deletes a SJA Form after user confirmation.
   * @param sjaFormId ID of the SJA Form to be deleted
   */
  DeleteSJAForm(sjaFormId: number) {
    if (sjaFormId > 0) {
      this.confirmationService.confirm({
        message: this.translate.instant('DELETE_THIS_RECORD'),
        accept: () => {
          this.loading = true;
          this.subscriptions.push(
            this.SJAFormServices.deleteSJAForm(sjaFormId).subscribe(
              (data: any) => {
                if (data) {
                  this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  if (this.parentId === FeatureKey.FOLLOW_UP) {
                    this.subscriptions.push(
                      this.SJAFormServices.getFollowUpSJAFormList(
                        BaseServices.BusinessId
                      ).subscribe((result: SjaForm[]) => {
                        this.sjaDataList = result;
                      })
                    );
                  } else {
                    this.subscriptions.push(
                      this.SJAFormServices.getSJAFormList(
                        this.parentId,
                        this.featureKey
                      ).subscribe((result: SjaForm[]) => {
                        this.sjaDataList = result;
                      })
                    );
                  }
                  this.loading = false;
                }
              }
            )
          );
        }
      });
    }
  }

  exportPdf(sjaFormId) {
    this.loading = true;
    let fileName = this.translate.instant('SJA_FORM');
    let filetype = 'pdf';
    let cultureInfo = sessionStorage.getItem('languageMode');
    this.subscriptions.push(
      this.SJAFormServices.exportSJAForm(
        sjaFormId,
        cultureInfo,
        BaseServices.ApplicationId
      ).subscribe(
        blob => {
          this.loading = false;
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${fileName}.${filetype.toLowerCase()}`;
          link.click();
        },
        error => {
          
        }
      )
    );
  }

  /**
   * Approve the selected SJA Forms.
   */
  saveApprovalNotice() {
    let approvalNotices = [];
    if (this.selectedSJA.length > 0) {
      const withResponsibleSign = this.selectedSJA.filter(
        (e: any) =>
          !!(e.DigitalResponsibleSign && e.DigitalResponsibleSign.trim())
      );
      const withoutResponsibleSign = this.selectedSJA.filter(
        (e: any) =>
          !e.DigitalResponsibleSign || !e.DigitalResponsibleSign.trim()
      );

      const total = this.selectedSJA.length;
      const approvable = withResponsibleSign.length;
      const invalid = withoutResponsibleSign.length;

      const proceedWithApproval = () => {
        if (approvable === 0) {
          this.selectedSJA = [];
          return;
        }
        withResponsibleSign.forEach((e: any) => {
          let approvalNotice = new ApprovalNotices();
          approvalNotice.Id = 0;
          approvalNotice.BusinessId = BaseServices.BusinessId;
          approvalNotice.SjaFormId = e.Id;
          approvalNotice.ApprovedBy = BaseServices.UserId;
          approvalNotice.ApprovedOn = new Date();
          approvalNotices.push(approvalNotice);
        });
        this.subscriptions.push(
          this.SJAFormServices.addApprovalNotices(approvalNotices).subscribe(
            addResult => {
              if (addResult) {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
              }
              this.bindApprovalNoticeList();
              if (this.parentId === FeatureKey.FOLLOW_UP) {
                this.subscriptions.push(
                  this.SJAFormServices.getFollowUpSJAFormList(
                    BaseServices.BusinessId
                  ).subscribe((result: SjaForm[]) => {
                    this.sjaDataList = result;
                  })
                );
              } else {
                this.subscriptions.push(
                  this.SJAFormServices.getSJAFormList(
                    this.parentId,
                    this.featureKey
                  ).subscribe((result: SjaForm[]) => {
                    this.sjaDataList = result;
                  })
                );
              }
            }
          )
        );
        this.selectedSJA = [];
      };

      if (invalid > 0) {
        const message = this.translate.instant('SJA_APPROVAL_PARTIAL_MESSAGE', {
          invalid,
          total,
          approvable
        });
        const acceptLabel = this.translate.instant(
          'SJA_APPROVAL_PARTIAL_APPROVE_LABEL',
          { count: approvable }
        );

        this.confirmationService.confirm({
          message,
          acceptLabel,
          rejectLabel: this.translate.instant('SWITCH_NO'),
          accept: () => proceedWithApproval()
        });
      } else {
        proceedWithApproval();
      }
    } else if (this.selectedSJA.length == 0) {
      this.showInfo = true;
    }
  }

  bindApprovalNoticeList() {
    this.approvalNotices = [];
    let roleId = Number(BaseServices.roleId);
    if (roleId != Roles.PORTAL && roleId != Roles.ADMIN) {
      if (this.parentId == 43) {
        this.subscriptions.push(
          this.SJAFormServices.getAllApprovedForKubaControl(
            this.featureKey
          ).subscribe(result => {
            if (result) {
              this.approvalNotices = [];
              this.approvalNotices = result;
            }
          })
        );
      } else {
        this.subscriptions.push(
          this.SJAFormServices.getAllApproved(this.featureKey).subscribe(
            result => {
              if (result) {
                this.approvalNotices = [];
                this.approvalNotices = result;
              }
            }
          )
        );
      }
    }
  }

  /**
   * Sends approval notice mail to all employees that have not approved all the SJA-signed
   * SJA-forms.
   *
   * NOTE: As of now, this is for Follow Up-module only!
   */
  sendApprovalNoticeMail() {
    this.confirmationService.confirm({
      message: this.translate.instant(
        'SJA_FORM_SEND_APPROVAL_NOTICE_MAIL_CONFIRMATION'
      ),
      accept: () => {
        this.loading = true;
        this.subscriptions.push(
          this.SJAFormServices.sendSjaFormEmail(
            BaseServices.BusinessId
          ).subscribe({
            next: () => {
              this.sentMail = true;
              this.notifications.add({ severity: 'success', summary: this.translate.instant('MAIL_SENT'), detail: this.translate.instant(
                  'SJA_FORM_APPROVAL_NOTICE_MAIL_SENT_SUCCESS'
                ) });
            },
            error: () => {
              
            },
            complete: () => {
              this.loading = false;
            }
          })
        );
      }
    });
  }

  public setCollapse(i: number): boolean {
    let isCollapsed = i === this.rowID;
    return !isCollapsed;
  }

  toggleClick(i: number): void {
    this.rowID = i;
    this.isCollapsed = !this.isCollapsed;
  }

  toggleClickHide(i: number): void {
    this.rowID = null;
  }

  bindBusinessDropDown() {
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Business = [];
        this.Business.push({ label: val.SELECT, value: null });
      })
    );

    let businessList = this.route.snapshot.data['business'];
    if (businessList) {
      businessList.forEach((repitition: any) => {
        this.Business.push({
          label: repitition.Name,
          value: repitition.Id
        });
      });
    }
  }

  /**
   * Fetches the SJA Form List based on the selected business.
   * (SJA Form List in the "Follow Up"-Module)
   */
  onBusinessChanged(event) {
    this.loading = false;
    if (event.value) {
      this.subscriptions.push(
        this.SJAFormServices.getFollowUpSJAFormList(event.value).subscribe(
          (res: SjaForm[]) => {
            this.sjaDataList = res;
            this.bindApprovalNoticeList();
          }
        )
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
